const img = (id) =>
    `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85`;

export const IMG = {
    // real project photo from our Google Business listing (self-hosted)
    googleFoyer: "/google-foyer.webp",
    // modern new-build home exterior (Toronto-area look)
    newBuild: img("photo-1606989254307-863681926e43"),
    // classic Toronto red brick home
    brickHome: img("photo-1636988813513-8e237ec1d251"),
    // brick row houses
    rowHouses: img("photo-1760662067400-e4977f513df7"),
    // luxury brick residence with lawn
    luxuryResidence: img("photo-1696237461860-630be53f179c"),
    // Toronto skyline, CN Tower at night
    skyline: img("photo-1543962226-818f4301073f"),
    // interior repaint in progress (paint buckets, ladder)
    prepWork: img("photo-1697967464378-1498c293e1aa"),
    // new build exterior under construction (siding stage)
    newBuildWorks: img("photo-1593012672015-4fabc32c67aa"),
    // painter working on ladder
    painterLadder: img("photo-1482731215275-a1f151646268"),
    // ladder on prepped wall
    preppedWall: img("photo-1584986152939-01133e0d31a2"),
    // room repaint, ladder work
    roomRepaint: img("photo-1696875371402-8a4db424e7bb"),
    // luxury interior from design system
    interiorLuxury: img("photo-1758957701419-2c6e266f7988"),
    // luxury exterior from design system
    exteriorLuxury: img("photo-1627141234469-24711efb373c"),
    // modern wall finish
    wallFinish: img("photo-1647082550285-119acfd169f2"),
    // architectural building
    architectural: img("photo-1721815693498-cc28507c0ba2"),
    // commercial facade
    commercialFacade: img("photo-1628744448840-55bdb2497bd4"),
};

export default IMG;

export const caledon = (n) => `/work/caledon-${String(n).padStart(2, "0")}.webp`;

export const orangeville = (n) => `/work/orangeville-${String(n).padStart(2, "0")}.webp`;

export const mcguire = (n) => `/work/mcguire-${String(n).padStart(2, "0")}.webp`;

export const mis = (n) => `/work/mis-${String(n).padStart(2, "0")}.webp`;

export const mssouth = (n) => `/work/mssouth-${String(n).padStart(2, "0")}.webp`;

export const cext = (n) => `/work/cext-${String(n).padStart(2, "0")}.webp`;